import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { AccountApi, AccountMarketplace, Response } from "@front/m19-api-client";
import { IButtonDirective, MODAL_DATA, ModalRef, ToasterService } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

export interface ModalUpdateVendorMetricsData {
  accountMarketplace: AccountMarketplace;
}

@Component({
  templateUrl: "./vendor-metrics-popup.component.html",
  imports: [TranslocoDirective, IButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalUpdateVendorMetricsComponent {
  private accountApi = inject(AccountApi);
  private toasterService = inject(ToasterService);

  modalData = inject(MODAL_DATA) as ModalUpdateVendorMetricsData;
  modalRef = inject(ModalRef);

  updateVendorMetrics(useSourcing: boolean) {
    this.modalData.accountMarketplace.useSourcingMetrics = useSourcing;
    this.accountApi
      .updateAccountMarketplace({
        accountId: this.modalData.accountMarketplace.accountId,
        marketplace: this.modalData.accountMarketplace.marketplace,
        organizationId: this.modalData.accountMarketplace.resourceOrganizationId,
        useSourcingMetrics: useSourcing,
      })
      .subscribe(
        (response: Response) => {
          if (response.code == 200) {
            this.toasterService.success(
              (useSourcing ? "Sourcing" : "Manufacturing") +
                " successfully selected for " +
                this.modalData.accountMarketplace.accountName,
            );
          } else {
            this.toasterService.error(response.message);
          }
        },
        (error) => this.toasterService.error(error),
      );
  }
}
